import { createSlice } from '@reduxjs/toolkit';

const syncSlice = createSlice({
  name: 'sync',
  initialState: {
    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
    isSyncing: false,
    pendingCount: 0,
    lastSyncAt: null,
    syncError: null,
  },
  reducers: {
    setOnline: (state, action) => {
      state.isOnline = action.payload;
      if (action.payload) state.syncError = null;
    },
    setSyncing: (state, action) => {
      state.isSyncing = action.payload;
    },
    setPendingCount: (state, action) => {
      state.pendingCount = action.payload;
    },
    setLastSyncAt: (state, action) => {
      state.lastSyncAt = action.payload;
    },
    setSyncError: (state, action) => {
      state.syncError = action.payload;
    },
  },
});

export const {
  setOnline,
  setSyncing,
  setPendingCount,
  setLastSyncAt,
  setSyncError,
} = syncSlice.actions;

export default syncSlice.reducer;
